/**
 * What a picker lists, for the message it shows when an unsearched listing comes back empty.
 */
export type EmptyListNudge = {
  /** The plural noun for what the picker lists, such as `projects`. */
  noun: string
  /** What the listed items belong to, read as "in this <container>", such as `organization`. */
  container?: string
}

const getEmptyListNudgeMessage = ({ noun, container }: EmptyListNudge) => {
  const expected = container ? `${noun} in this ${container}` : noun
  return `No ${noun} found. If you expect ${expected}, check that the connection's account has access to them.`
}

/**
 * What a settled, empty list says: the nudge, unless the list answers a typed search or a failed
 * request, in which case `fallback`.
 */
export const getEmptyListMessage = <TFallback extends string | undefined>({
  emptyListNudge,
  isSearched,
  isError,
  fallback,
}: {
  emptyListNudge: EmptyListNudge | undefined
  isSearched: boolean
  isError: boolean
  fallback: TFallback
}) => (emptyListNudge && !isSearched && !isError ? getEmptyListNudgeMessage(emptyListNudge) : fallback)
